import {useAnalytics} from '@github-ui/use-analytics'
import {Banner} from '@primer/react'
import {useCallback, useEffect, useState} from 'react'

export function StaleCacheBanner() {
  const [bannerVisible, setBannerVisible] = useState(false)
  const {sendAnalyticsEvent} = useAnalytics()

  const handleStaleCacheWarning = useCallback(() => {
    setBannerVisible(true)
    sendAnalyticsEvent('issues.stale_cache_warning.shown')
  }, [sendAnalyticsEvent])

  useEffect(() => {
    window.addEventListener('stale-cache-warning', handleStaleCacheWarning)
    return () => {
      window.removeEventListener('stale-cache-warning', handleStaleCacheWarning)
    }
  }, [handleStaleCacheWarning])

  if (!bannerVisible) return null

  const handleReload = () => {
    window.location.reload()
  }

  return (
    <div
      style={{
        marginTop: 'var(--base-size-16)',
        marginBottom: 'var(--base-size-24)',
        marginInline: 'var(--base-size-16)',
      }}
    >
      <Banner
        variant="warning"
        title="Stale cache warning"
        hideTitle
        description={
          <>
            Failed to fetch data,{' '}
            <button
              onClick={handleReload}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                color: 'inherit',
                textDecoration: 'underline',
                cursor: 'pointer',
                font: 'inherit',
              }}
            >
              click here to reload the page
            </button>
            .
          </>
        }
        aria-live="polite"
        aria-atomic="true"
      />
    </div>
  )
}

try{ StaleCacheBanner.displayName ||= 'StaleCacheBanner' } catch {}